const TFoodItem = {
    // English
    "enUS": {
        'EDIT': 'Edit',
        'ENABLED': 'Enabled',
        'DISABLED': 'Disabled',
        'DELETE': 'Delete',
        'DELETE_FOOD_TITLE': 'Delete food',
        'DELETE_FOOD_TEXT': 'Deleting this food will delete all other data directly associated with it. Are you sure you want to do it?',
        'CONFIRM_DELETE_FOOD_TEXT': 'Delete',
        'CANCEL': 'Cancel',
    },
    // Spanish
    "esMX": {
        'EDIT': 'Editar',
        'ENABLED': 'Activo',
        'DISABLED': 'Inactivo',
        'DELETE': 'Borrar',
        'DELETE_FOOD_TITLE': 'Borrar comida',
        'DELETE_FOOD_TEXT': 'Borrar esta comida borrará cualquier otra información directamente asociada con ella. Seguro que desea borrarla?',
        'CONFIRM_DELETE_FOOD_TEXT': 'Borrar',
        'CANCEL': 'Cancelar',
    }
}
export default TFoodItem;